<template>
  <div class="phone-view">
    <div
      class="phone-item wow bounceInUpSlow"
      :data-wow-delay="`${0.2 * index}s`"
      v-for="(item,index) in phones"
      :key="index"
    >
      <div class="cover" @click="showModel(item.img)">
        <img :src="item.img" alt />
      </div>
    </div>
    <div class="phone-model" v-if="showPhone">
      <div class="pop-body">
        <div class="cent">
          <img :src="selectImg" alt />
        </div>
      </div>
      <div class="hask" @click="showPhone = false"></div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref } from 'vue';
const porps = defineProps({
  phones: Array,
})
const showPhone = ref(false)
const selectImg = ref('')
const showModel = (src) => {
  showPhone.value = true
  selectImg.value = src
}
</script>
<style lang="less" scoped>
.phone-view {
  display: flex;
  flex-wrap: wrap;
  .phone-item {
    width: 25%;
    padding: 16px 8px;
    .cover {
      height: 560px;
      overflow: hidden;
      position: relative;
      background: #eee;
      &:after,
      &:before {
        display: block;
        content: "";
        opacity: 0;
        transition: all 0.1s ease-in;
      }
      &:before {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.65);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
      }
      &:after {
        font-family: "iconfont" !important;
        display: block;
        content: "\e67e";
        font-size: 32px;
        position: absolute;
        z-index: 2;
        color: #fff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      &:hover {
        &:after,
        &:before {
          opacity: 1;
          transition: all 0.1s ease-in;
        }
      }
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
.phone-model {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  left: 0;
  top: 0;
  display: flex;
  .hask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.75);
  }
  .pop-body {
    width: 320px;
    height: 667px;
    margin: auto;
    position: relative;
    z-index: 3;
    border-radius: 40px;
    background-color: #eee;
    border: 12px solid #4d566a;
    box-shadow:0 0 12px rgba(255,255,255,0.25) ;
    overflow: hidden;
    &:before{
      display: block;
      content: "";
      width: 200px;
      height: 20px;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      background-color: #4d566a;
      position: absolute;
      left:50%;
      top:0;
      z-index: 3;
      transform: translateX(-50%);
    }
    .cent {
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #535353;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
    }
  }
}
</style>